import styled from 'styled-components';

import { Container as ColorsListContainer } from '~organisms/ColorsList';
import { SortAndFiltersSt } from '~organisms/SortAndFiltersSection';

const filterWidth = '255rem';

export const Container = styled.div({
  position: 'relative',

  paddingBlockEnd: '100rem',

  [`${ColorsListContainer}`]: {
    marginInlineStart: '25rem',
  },
});

export const ContentContainer = styled.div({
  display: 'flex',
});

export const ChildrenContainer = styled.div({
  flex: '1',
});

export const FilterContainer = styled.div(({ theme }) => ({
  borderInlineEnd: `1px solid ${theme.filter.secondary.border}`,
  [`${SortAndFiltersSt.Container}`]: {
    inlineSize: filterWidth,
    paddingInlineEnd: '20rem',
  },
}));
